export default "__VITE_ASSET__bee30a83__"